import { useSelector } from 'react-redux';

import { FormField, Select, Typography } from 'src/shared';
import { i18, trb, translationGroups } from '../../../../../Utilities';

export const FieldSEPAPaymentType = () => {
  const { PTR } = useSelector((state: any) => state.PMCReducers);

  return (
    <>
      <Typography.Title
        level={2}
        className="form-part-title"
      >
        {trb(i18.PaymentParts.PaymentType)}
      </Typography.Title>
      <FormField
        name="Payment.SEPAPaymentType"
        label={trb(i18.Labels.SEPAPaymentType)}
      >
        <Select
          options={PTR?.SEPAPaymentTypes?.map((item: any) => ({
            label: trb(translationGroups.SEPAPaymentTypes + item.Code),
            value: item.Code,
          }))}
        />
      </FormField>
    </>
  );
};
